<template>
  <v-toolbar dark color="header" class="mb-4">
    <v-toolbar-title>
      <slot></slot>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <gg-btn v-if="!hideClose" icon dark elevation="0" @click="$emit('close')" aria-label="Close">
      <v-icon>mdi-close</v-icon>
    </gg-btn>
  </v-toolbar>
</template>

<script>
export default {
  name: 'GGToolbar',
  props: {
    hideClose: {
      type: [Boolean, String]
    }
  }
}
</script>
